<template>
  <div class="price-list-proposal-detail-view">
    <v-row>
      <v-col class="hidden-sm-and-down" cols="0" md="3">
        <SsoUserMenu v-if="isSsoAuthenticated" class="menu-navigator" />
        <v-divider></v-divider>
        <MenuNavigator class="menu-navigator" />
      </v-col>
      <v-col cols="12" md="9">
        <ProfileTitle :category="category" />

        <PriceListDetail :isPriceListProposal="true" />
      </v-col>
    </v-row>
  </div>
</template>
<style lang="scss">
.price-list-proposal-detail-view {
}
</style>
<script>
import MenuNavigator from "@/components/profile/MenuNavigator";
import ProfileTitle from "@/components/profile/ProfileTitle";
import PriceListDetail from "@/components/priceList/PriceListDetail.vue";

import categoryMixin from "~/mixins/category";
import { mapGetters } from "vuex";
import SsoUserMenu from "@/components/profile/SsoUserMenu.vue";

export default {
  name: "PriceListProposalDetailView",
  mixins: [categoryMixin],
  components: {
    MenuNavigator,
    ProfileTitle,
    PriceListDetail,
    SsoUserMenu
  },
  computed: {
    ...mapGetters({
      isSsoAuthenticated: "cart/isSsoAuthenticated"
    })
  },
  methods: {}
};
</script>
